import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import { lighten } from "@material-ui/core";

export const OperatedSwitchButton = withStyles((theme) => ({
  root: {
    width: 30,
    height: 18,
    maxHeight: 18,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.info.main,
      },
    },
  },
  thumb: {
    width: 14,
    height: 14,
    boxShadow: "none",
  },
  track: {
    borderRadius: 9,
    opacity: 1,
    backgroundColor: "#c2c4cb",
  },
  checked: {},
  disabled: {
    "& + $track": {
      backgroundColor: `${lighten(theme.palette.primary.main, 0.9)} !important`,
      opacity: "1 !important",
    },
    "&": {
      color: "#FFF !important",
    },
  },
}))(Switch);
